import { jsx as e } from "react/jsx-runtime";
import { cn as m } from "../../lib.js";
import "../../extend-tailwind-merge-e63b2b56.js";
function a({ className: r, ...o }) {
  return /* @__PURE__ */ e("div", { className: m("animate-pulse rounded-md bg-gray-108", r), ...o });
}
export {
  a as Skeleton
};
